<template>
  <el-form :model="registerForm" :rules="registerRules" ref="registerFormRef" class="register-form">
    <el-form-item :label="$t('register.email')" prop="email" :label-width="formLabelWidth">
      <el-input v-model="registerForm.email" :placeholder="$t('register.email')"></el-input>
    </el-form-item>
    <el-form-item :label="$t('register.password')" prop="password" :label-width="formLabelWidth">
      <el-input v-model="registerForm.password" type="password" :placeholder="$t('register.password')"></el-input>
    </el-form-item>
    <el-form-item :label="$t('register.confirmPassword')" prop="confirmPassword" :label-width="formLabelWidth">
      <el-input v-model="registerForm.confirmPassword" type="password" :placeholder="$t('register.confirmPassword')"></el-input>
    </el-form-item>

    <el-form-item class="form-actions">
      <el-button type="primary" @click="handleRegister" class="submit-button">{{ $t('register.submit') }}</el-button>
      <el-button @click="resetRegisterForm" class="reset-button">{{ $t('register.reset') }}</el-button>
    </el-form-item>
  </el-form>
</template>

<script setup>
import { ref } from 'vue';
import { defineEmits } from 'vue';
import { ElMessage } from 'element-plus';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const emit = defineEmits(['close']); // 定义 close 事件

// 注册表单数据
const registerForm = ref({
  email: '',
  password: '',
  confirmPassword: '',
});

// 表单标签宽度
const formLabelWidth = '120px';

// 注册表单验证规则
const registerRules = ref({
  email: [
    { required: true, message: t('register.emailRequired'), trigger: 'blur' },
    { type: 'email', message: t('register.emailInvalid'), trigger: 'blur' },
  ],
  password: [{ required: true, message: t('register.passwordRequired'), trigger: 'blur' }],
  confirmPassword: [
    { required: true, message: t('register.confirmPasswordRequired'), trigger: 'blur' },
    {
      validator: (rule, value, callback) => {
        if ( value !== registerForm.value.password ) {
          callback(new Error(t('register.passwordMismatch')));
        } else {
          callback();
        }
      },
      trigger: 'blur',
    },
  ],
});

// 处理注册
const handleRegister = () => {
  ElMessage.success(t('register.success'));
  console.log('注册表单数据：', registerForm.value);
  emit('close'); // 关闭对话框
};

// 重置注册表单
const resetRegisterForm = () => {
  registerForm.value = {
    email: '',
    password: '',
    confirmPassword: '',
  };
};
</script>

<style scoped>
.register-form {
  justify-content: center;
  padding: 20px;
  background: #ffffff;
  border-radius: 8px;
  margin: 20px; /* 增加边距 */
}

:deep(.el-dialog) {
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

:deep(.el-dialog__header) {
  background: #409EFF;
  color: white;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  padding: 16px;
}

:deep(.el-dialog__title) {
  color: white;
  font-size: 18px;
}

:deep(.el-form-item__label) {
  color: #333;
  font-size: 14px;
  text-align: left; /* 标签左对齐 */
}

/*
:deep(.el-input__inner) {
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  padding: 10px 12px;
  font-size: 14px;
  box-shadow: none;
}

:deep(.el-input__inner:focus) {
  border-color: #dcdfe6;
  box-shadow: none;
}*/

.form-actions {
  margin-top: 30px;
  display: flex; /* 使用 flex 布局 */
  justify-content: center; /* 水平居中 */
  gap: 10px; /* 按钮之间的间距 */
  width: 100%; /* 确保宽度占满父容器 */
  margin-left: 100px;

}

.submit-button {
  background-color: #409EFF;
  border-color: #409EFF;
  color: white;
  font-size: 14px;
  padding: 10px 20px;
  border-radius: 4px;
}

.submit-button:hover {
  background-color: #66b1ff;
  border-color: #66b1ff;
}

.reset-button {
  background-color: white;
  border-color: #dcdfe6;
  color: #333;
  font-size: 14px;
  padding: 10px 20px;
  border-radius: 4px;
}

.reset-button:hover {
  background-color: #f5f7fa;
  border-color: #c0c4cc;
}
</style>
